<div class="modal-header">
  <h4 class="modal-title">Message broadcast</h4>
  <button (click)="bsModalRef.hide()" aria-label="Fermer" class="btn-close" type="button"></button>
</div>

<div class="modal-body">
  <form class="edit-form">
    <div class="field-group">
      <label class="form-label">Icône</label>
      <div class="icon-select-row">
        <div class="icon-select-item">
          <mir-message-icon-selector
            icon="fa-info-square"
            [message]="message"
          ></mir-message-icon-selector>
        </div>
        <div class="icon-select-item">
          <mir-message-icon-selector
            icon="fa-question-square"
            [message]="message"
          ></mir-message-icon-selector>
        </div>
        <div class="icon-select-item">
          <mir-message-icon-selector
            icon="fa-times-square"
            [message]="message"
          ></mir-message-icon-selector>
        </div>
        <div class="icon-select-item">
          <mir-message-icon-selector
            icon="fa-exclamation"
            [message]="message"
          ></mir-message-icon-selector>
        </div>
        <div class="icon-select-item">
          <mir-message-icon-selector
            icon="fa-wrench"
            [message]="message"
          ></mir-message-icon-selector>
        </div>
        <div class="icon-select-item">
          <mir-message-icon-selector
            icon="fa-fire"
            [message]="message"
          ></mir-message-icon-selector>
        </div>
      </div>
    </div>

    <div class="field-group">
      <label class="form-label">SDIS</label>
      <p class="form-text">
        Sans SDIS spécifié, le message est visible sur tous les Mir du même environnement.
      </p>
      @if (message.sdis?.length > 0) {
      <div class="sdis-chips">
        @for (aSdis of message.sdis; track aSdis) {
        <span class="badge rounded-pill sdis-chip">
          {{ aSdis }}
          <button
            type="button"
            class="sdis-chip-remove"
            aria-label="Retirer"
            (click)="rmSdis(aSdis)"
          >
            <em class="fal fa-times"></em>
          </button>
        </span>
        }
      </div>
      }
      <div class="sdis-add">
        <input #sdisToAdd class="form-control" placeholder="N° SDIS" type="number" />
        <button (click)="addSdis(sdisToAdd)" class="btn btn-light" type="button">
          Ajouter
        </button>
      </div>
    </div>

    <div class="field-group">
      <label class="form-label" for="criticity">Criticité</label>
      <input
        class="form-control"
        [(ngModel)]="message.criticity"
        id="criticity"
        name="criticity"
      />
    </div>

    <div class="field-group">
      <label class="form-label" for="dateFrom">Date (depuis)</label>
      <input
        class="form-control"
        [(ngModel)]="message.dateFrom"
        id="dateFrom"
        name="dateFrom"
      />
    </div>

    <div class="field-group">
      <label class="form-label" for="subject">Sujet</label>
      <input
        class="form-control"
        [(ngModel)]="message.subject"
        id="subject"
        name="subject"
      />
    </div>

    <div class="field-group">
      <label class="form-label" for="body">Message</label>
      <input
        class="form-control"
        [(ngModel)]="message.body"
        id="body"
        name="body"
      />
    </div>
  </form>
</div>

<div class="modal-footer">
  <button (click)="onSaveMessage()" class="btn btn-dark" type="button">
    <em class="fal fa-check"></em> Enregistrer
  </button>
</div>
